import React, { useState } from 'react';
import {
    Card, CardContent, Typography, Button, Alert,
    Stack, Box, IconButton, Tooltip, useTheme
} from '@mui/material';
import LinkRoundedIcon from '@mui/icons-material/LinkRounded';
import ContentCopyRoundedIcon from '@mui/icons-material/ContentCopyRounded';
import ShareRoundedIcon from '@mui/icons-material/ShareRounded';

const InviteLinkCard = ({ activeTeamId, handleGenerateInvite, iLoading, iData, iError }) => {
    const theme = useTheme();
    const [copied, setCopied] = useState(false);

    const fullLink = iData?.token ? `${window.location.origin}/join/${iData.token}` : '';

    const handleCopy = () => {
        if (!fullLink) return;
        navigator.clipboard.writeText(fullLink);
        setCopied(true);
        setTimeout(() => setCopied(false), 2000);
    };

    return (
        <Card sx={{
            borderRadius: "12px",
            border: '1px solid',
            borderColor: 'divider',
            background: 'rgba(255,255,255,0.01)',
            backdropFilter: 'blur(20px)',
            boxShadow: 'none'
        }}>
            <CardContent sx={{ p: 4 }}>
                <Stack direction="row" spacing={2} alignItems="center" sx={{ mb: 3 }}>
                    <Box sx={{
                        p: 1.5,
                        borderRadius: "12px",
                        bgcolor: 'rgba(190, 242, 100, 0.1)',
                        color: 'primary.main',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center'
                    }}>
                        <LinkRoundedIcon fontSize="medium" />
                    </Box>
                    <Box>
                        <Typography variant="h5" sx={{ fontWeight: 900, mb: 0.5 }}>
                            Einladungs <span style={{ color: theme.palette.primary.main }}>Link</span>
                        </Typography>
                        <Typography variant="body2" sx={{ color: 'text.secondary', fontWeight: 600 }}>
                            Schneller Beitritt für neue Spieler
                        </Typography>
                    </Box>
                </Stack>

                <Box sx={{ mb: 3 }}>
                    <Typography variant="body2" sx={{ color: 'text.secondary', fontWeight: 600, mb: 2 }}>
                        Teile diesen Link mit deinen Spielern. Jeder mit diesem Link kann deinem Team direkt beitreten.
                    </Typography>
                    <Button
                        variant="contained"
                        fullWidth
                        // onClick={handleGenerateInvite}
                        onClick={() => alert("Gibts noch nicht")}
                        disabled={iLoading || !activeTeamId}
                        startIcon={<ShareRoundedIcon />}
                        sx={{
                            borderRadius: "12px",
                            fontWeight: 900,
                            py: 1.5,
                            bgcolor: 'primary.main',
                            color: '#000',
                            '&:hover': { bgcolor: 'primary.dark' }
                        }}
                    >
                        {iData?.success ? 'Neuen Link generieren' : 'Link jetzt generieren'}
                    </Button>
                </Box>

                {iData?.success && (
                    <Box sx={{
                        p: 2.5,
                        bgcolor: 'rgba(255,255,255,0.03)',
                        borderRadius: "12px",
                        border: '1px solid',
                        borderColor: 'primary.main',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'space-between',
                        gap: 2
                    }}>
                        <Box sx={{ overflow: 'hidden' }}>
                            <Typography variant="caption" sx={{ fontWeight: 900, color: 'primary.main', textTransform: 'uppercase', display: 'block', mb: 0.5 }}>
                                Aktiver Link
                            </Typography>
                            <Typography variant="body2" sx={{ fontWeight: 800, whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>
                                {fullLink}
                            </Typography>
                        </Box>
                        <Tooltip title={copied ? "Kopiert!" : "Link kopieren"}>
                            <IconButton
                                onClick={handleCopy}
                                sx={{
                                    bgcolor: 'primary.main',
                                    color: '#000',
                                    '&:hover': { bgcolor: 'primary.dark' }
                                }}
                            >
                                <ContentCopyRoundedIcon fontSize="small" />
                            </IconButton>
                        </Tooltip>
                    </Box>
                )}

                {iError && (
                    <Alert severity="error" sx={{ mt: 2, borderRadius: "12px", fontWeight: 700 }}>
                        {iError}
                    </Alert>
                )}
            </CardContent>
        </Card>
    );
};

export default InviteLinkCard;
